import React from "react";
import { PrefillInput } from "@components/input";

export const UnitNumber = () => (
  <PrefillInput
    title="Unit Number"
    placeholder="If applicable"
    name="unitNumber"
  />
);